import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

/**
 * Guard para verificar que existe un tenant cargado
 * Se usa en rutas que requieren contexto de tenant
 * Maneja auto-login y carga del tenant si es necesario
 */
export const tenantGuard: CanActivateFn = (route, state) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  console.log('🏢 Tenant Guard - Verificando tenant...');
  console.log('🏢 URL:', state.url);
  console.log('🏢 Query Params:', route.queryParams);

  // Detectar tokens de auto-login:
  // autoLoginToken = owner token (flujo selectBusiness)
  // elt            = employee login token (flujo onboarding)
  const hasAutoLoginToken = !!route.queryParams['autoLoginToken'] || !!route.queryParams['elt'];

  let tenant = tenantService.getCurrentTenant();
  
  // Si ya hay tenant cargado, permitir acceso
  if (tenant) {
    console.log('✅ Tenant ya cargado:', tenant.slug);
    return true;
  }

  console.log('⚠️ No hay tenant en storage, intentando detectar del dominio...');

  // Intentar detectar el tenant del dominio
  const tenantSlug = tenantService.detectTenantFromDomain();
  
  if (!tenantSlug) {
    // No es un subdominio de tenant, redirigir al dominio principal
    console.warn('❌ No se pudo detectar tenant del dominio');
    router.navigate(['/']);
    return false;
  }

  console.log('🔍 Tenant detectado del dominio:', tenantSlug);

  // Si viene con autoLoginToken, permitir el paso y dejar que se cargue el tenant
  // El AppComponent o el employeeAuthGuard se encargarán de cargar el tenant
  if (hasAutoLoginToken) {
    console.log('✅ Permitiendo paso con autoLoginToken (tenant se cargará después)');
    return true;
  }

  // Cargar la información del tenant desde el API
  console.log('📡 Cargando información del tenant desde API...');
  return tenantService.loadTenantInfo(tenantSlug).pipe(
    map((loadedTenant) => {
      console.log('✅ Tenant cargado exitosamente:', loadedTenant.slug);
      return true;
    }),
    catchError((error) => {
      console.error('❌ Error al cargar tenant:', error);
      // Si falla la carga del tenant, redirigir al dominio principal
      router.navigate(['/']);
      return of(false);
    })
  );
};
